<template>
  <a-modal
    ref="createModal"
    :title="editStatus === 'edit' ? '编辑标准工艺路线' : '新建标准工艺路线'"
    :width="1000"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <a-form-model ref="ruleForm" :model="queryParams" :rules="rules" layout="inline" :labelCol="{ style: { width: '90px' } }">
      <a-row>
        <a-col :md="8" :sm="24">
          <a-form-model-item label="加工组织" prop="organizationCode" class="code-select">
            <global-select
              :value.sync="queryParams.organizationCode"
              selectType="selectAssemble"
              requestApi="/system/user/inventOrgList"
              :selectItem="{ value: 'realValue', label: 'label' }"
              :dropdown-match-select-width="false"
              :allowClear="false"
              :assembleLabel="true"
              :disabled="editStatus === 'edit'"
              @change="inventOrgValueOnChange"
            />
          </a-form-model-item>
        </a-col>
        <a-col v-if="editStatus === 'edit'" :md="11" :sm="24">
          <a-form-model-item label="工艺路线" class="itemcode" prop="id">
            <!-- <a-select v-model="queryParams.id" @change="idOnChange">
              <a-select-option v-for="(item) in routingList" :key="item.id">{{ item.routingCode }}</a-select-option>
            </a-select> -->
            <a-input v-model="queryParams.routingCode" class="routingCode" disabled />
            &nbsp;&nbsp;&nbsp;&nbsp;
            <a-input v-model="queryParams.routingDesc" class="ml10" />
          </a-form-model-item>
        </a-col>
        <a-col v-if="editStatus === 'add'" :md="11" :sm="24">
          <a-form-model-item label="工艺路线" class="itemcode" prop="routingCode">
            <a-input v-model="queryParams.routingCode" class="routingCode" />
            &nbsp;&nbsp;&nbsp;&nbsp;
            <a-input v-model="queryParams.routingDesc" class="ml10" />
          </a-form-model-item>
        </a-col>
        <a-col :md="5" :sm="24" v-if="editStatus === 'edit'">
          <a-form-model-item label="状态">
            <a-switch :checked="queryParams.routingStatus === 'Y'" @change="statusOnChange(queryParams)" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <div class="table-page-operator-wrapper mt10">
      <a-button @click="addLine()" type="primary">新增行</a-button>
    </div>
    <a-table
      ref="modalTable"
      :columns="columns"
      :data-source="tableList"
      :pagination="false"
      row-key="indexId"
      class="tableInput"
      :scroll="{ x: 900, y: 200 }"
    >
      <!-- 工序号 -->
      <span slot="operationSeqNumTitle">
        <i class="toRequired">*</i>工序号
      </span>
      <template slot="operationSeqNum" slot-scope="text, record">
        <a-input v-model="record.operationSeqNum" />
      </template>
      <!-- 工序编码 -->
      <span slot="operationCodeTitle">
        <i class="toRequired">*</i>工序编码
      </span>
      <template slot="operationId" slot-scope="text, record">
        <a-select show-search :value="record.operationCode" optionFilterProp="children" @change="(operationId) => operationCodeOnChange(operationId, record)">
          <a-select-option v-for="(item) in operationCodeList" :key="item.selectedValue">{{ `${item.label}-${item.realValue}` }}</a-select-option>
        </a-select>
      </template>
      <!-- 工序说明 -->
      <template slot="operationDesc" slot-scope="text, record">
        <a-input v-model="record.operationDesc" disabled />
      </template>
      <!-- 工序类型 -->
      <span slot="operationTypeTitle">
        <i class="toRequired">*</i>工序类型
      </span>
      <template slot="operationType" slot-scope="text, record">
        <a-select v-model="record.operationType">
          <a-select-option v-for="(item) in operationTypeList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
        </a-select>
      </template>
      <!-- 工时(分钟) -->
      <template slot="workingHours" slot-scope="text, record">
        <a-input-number v-model="record.workingHours" :min="0" @change="workingHoursChange(record)" />
      </template>
      <!-- 配置人数 -->
      <template slot="personnelAllocation" slot-scope="text, record">
        <a-input-number v-model="record.personnelAllocation" :min="0" :precision="0" @change="personnelAllocationChange(record)" />
      </template>
      <!-- 产能效率(套/分钟) -->
      <template slot="efficiency" slot-scope="text, record">
        <a-input-number v-model="record.efficiency" :min="0" @change="efficiencyChange(record)" />
      </template>
      <!-- 产能(套/时) -->
      <template slot="unitCapacity" slot-scope="text, record">
        <a-input-number v-model="record.unitCapacity" :min="0" />
      </template>
      <span slot="operation" slot-scope="text, record">
        <a @click="handleDelete(tableList, record)" v-hasPermi="['bom:bomRoutingHeader:remove']">删除</a>
      </span>
    </a-table>
  </a-modal>
</template>

<script>
import { apiBomOperationFindList, apiBomRoutingHeaderFindList, apiBomRoutingHeaderUpdate, apiBomRoutingHeaderAdd } from '@/api/mes/basedata/standardProcess'

export default {
  props: {
    inventOrg: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      columns: [
        {
          // title: '工序号',
          dataIndex: 'operationSeqNum',
          scopedSlots: { customRender: 'operationSeqNum', title: "operationSeqNumTitle" },
          width: 100,
          align: 'center'
        },
        {
          // title: '工序编码',
          dataIndex: 'operationId',
          scopedSlots: { customRender: 'operationId', title: "operationCodeTitle" },
          width: 140,
          align: 'center'
        },
        {
          title: '工序说明',
          dataIndex: 'operationDesc',
          scopedSlots: { customRender: 'operationDesc' },
          width: 100,
          align: 'center'
        },
        {
          // title: '工序类型',
          dataIndex: 'operationType',
          scopedSlots: { customRender: 'operationType', title: "operationTypeTitle" },
          width: 140,
          align: 'center'
        },
        {
          title: '工时(分钟)',
          dataIndex: 'workingHours',
          scopedSlots: { customRender: 'workingHours' },
          width: 140,
          align: 'center'
        },
        {
          title: '配置人数',
          dataIndex: 'personnelAllocation',
          scopedSlots: { customRender: 'personnelAllocation' },
          width: 100,
          align: 'center'
        },
        // {
        //   title: '产能类型',
        //   dataIndex: 'capacityType',
        //   scopedSlots: { customRender: 'capacityType' },
        //   width: 140,
        //   align: 'center'
        // },
        {
          title: '产能效率(套/分钟)',
          dataIndex: 'efficiency',
          scopedSlots: { customRender: 'efficiency' },
          width: 150,
          align: 'center'
        },
        {
          title: '产能(套/时)',
          dataIndex: 'unitCapacity',
          scopedSlots: { customRender: 'unitCapacity' },
          width: 120,
          align: 'center'
        },
        {
          title: '操作',
          width: 70,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      tableList: [],
      editStatus: "",
      operationCodeList: [], // 工序编码
      operationTypeList: [], // 工序类型
      queryParams: {
        organizationCode: "",
        id: "",
        routingCode: "",
        routingDesc: "",
        routingStatus: "Y",
        isStandardRoutingFlag: "Y"
      },
      routingList: [], // 工艺路线
      deleteList: [],
      // 表单校验
      rules: {
        organizationCode: [
          { required: true, message: '加工组织不能为空', trigger: 'change' }
        ],
        routingCode: [
          { required: true, message: '工艺路线不能为空', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.getLookupList('MES_OPERATION_TYPE', 'operationTypeList')
  },
  methods: {
    // 工时
    workingHoursChange (record) {
      this.efficiencyHandle(record)
    },
    // 配置人数
    personnelAllocationChange (record) {
      this.efficiencyHandle(record)
    },
    // 产能效率
    efficiencyChange (record) {
      this.unitCapacityHandle(record)
    },
    efficiencyHandle (record) {
      if (record.workingHours && record.personnelAllocation) { // 工时、配置人数
        record.efficiency = this.$parseFloatToFixed(Number(record.workingHours) / Number(record.personnelAllocation), 6) // 产能效率
        this.unitCapacityHandle(record)
      }
    },
    unitCapacityHandle (record) {
      if (record.efficiency) { // 产能效率
        record.unitCapacity = this.$parseFloatToFixed(60 / Number(record.efficiency), 6) // 产能
      }
    },
    // 工艺路线
    idOnChange (val) {
      this.queryParams.routingDesc = this.routingList.find(item => val === item.id).routingDesc
    },
    // 加工组织
    inventOrgValueOnChange (val, status) {
      if (status !== "yes") {
        this.queryParams.id = ""
        this.queryParams.routingDesc = ""
        this.tableList.forEach(item => {
          item.operationDesc = ''
          item.operationCode = ''
          item.operationId = ''
        })
      }
      apiBomRoutingHeaderFindList({ organizationCode: val }).then(res => {
        if (res && res.length > 0) {
          this.routingList = res
        }
      })
      this.getOperationCodeList()
    },
    statusOnChange (queryParams) {
      queryParams.routingStatus = queryParams.routingStatus === 'Y' ? 'N' : 'Y'
    },
    // 删除
    handleDelete (arr, record) {
      arr.forEach((item, index) => {
        if (item.indexId === record.indexId) {
          if (this.editStatus === "edit" && record.id) {
            this.deleteList.push(record)
          }
          arr.splice(index, 1);
        }
      });
    },
    show (status, val) {
      if (val) {
        this.editStatus = status
        val.bomRoutingLineDtoList && val.bomRoutingLineDtoList.forEach((item, index) => {
          item.indexId = index + 1
        });
        this.queryParams = val
        this.tableList = val.bomRoutingLineDtoList
        this.inventOrgValueOnChange(this.queryParams.organizationCode, "yes")
      } else {
        this.editStatus = status
        this.tableList = []
        this.addLine()
      }
      this.visible = true

      setTimeout(() => {
        this.columns = JSON.parse(JSON.stringify(this.columns))
      }, 300)
    },
    // 新增行
    addLine () {
      const arr = JSON.parse(JSON.stringify(this.tableList))
      const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
      const obj = {
        operationSeqNum: (Number(indexId) + 1) * 10,
        operationId: "",
        operationDesc: "",
        operationType: "",
        workingHours: "",
        personnelAllocation: "",
        capacityType: "",
        efficiency: "",
        unitCapacity: "",
        indexId: Number(indexId) + 1
      }
      arr.push(obj)
      this.tableList = arr
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 保存
    confirm () {
      let flag = false
      for (let i = 0; i < this.tableList.length; i++) {
        if (!this.tableList[i].operationSeqNum || !this.tableList[i].operationId || !this.tableList[i].operationType) {
          this.$message.warning('必填项不能为空！')
          flag = true
          return
        }
        if (this.tableList[i].workingHours === 0) {
          this.$message.warning('工时(分钟) 不能为0')
          flag = true
          return
        }
        if (this.tableList[i].personnelAllocation === 0) {
          this.$message.warning('配置人数 不能为0')
          flag = true
          return
        }
        if (this.tableList[i].efficiency === 0) {
          this.$message.warning('产能效率(套/分钟) 不能为0')
          flag = true
          return
        }
        if (this.tableList[i].unitCapacity === 0) {
          this.$message.warning('产能(套/时) 不能为0')
          flag = true
          return
        }
      }
      if (flag) {
        return false
      }
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.confirmLoading = true
          if (this.editStatus === 'edit') {
            this.queryParams.bomRoutingLineDtoList = this.tableList
            this.queryParams.bomRoutingLineDtoDeleteList = this.deleteList
            apiBomRoutingHeaderUpdate(this.queryParams).then(response => {
              if (response.code === 200) {
                this.$message.success('修改成功')
                // 关闭本组件
                this.visible = false
                // 调用外部刷新列表方法
                this.$emit('handle-success', "edit", this.queryParams)
                // 刷新表单
                this.reset()
                this.confirmLoading = false
              } else {
                this.$message.error(response.msg)
                this.confirmLoading = false
              }
            }).catch(e => {
              this.confirmLoading = false
            })
          } else {
            this.queryParams.bomRoutingLineDtoList = this.tableList
            apiBomRoutingHeaderAdd(this.queryParams).then(response => {
              if (response.code === 200) {
                this.$message.success('新增成功')
                // 关闭本组件
                this.visible = false
                // 调用外部刷新列表方法
                this.$emit('handle-success', "add", this.queryParams)
                // 刷新表单
                this.reset()
                this.confirmLoading = false
              } else {
                this.$message.error(response.msg)
                this.confirmLoading = false
              }
            }).catch(e => {
              this.confirmLoading = false
            })
          }
        }
      })
    },
    // 表单重置
    reset () {
      this.queryParams = {
        organizationCode: "",
        id: "",
        routingCode: "",
        routingDesc: "",
        routingStatus: "Y",
        isStandardRoutingFlag: "Y"
      }
      this.tableList = []
      this.routingList = []
      this.deleteList = []
    },
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        this[arr] = response.rows
      })
    },
    // 工序编码
    operationCodeOnChange (selectedOperationId, record) {
      const tempSelectedItem = this.operationCodeList.find(item => selectedOperationId === item.selectedValue)
      record.operationId = selectedOperationId
      record.operationDesc = tempSelectedItem.realValue
      record.operationCode = tempSelectedItem.label
    },
    // 工序编码-下拉框数据
    getOperationCodeList () {
      apiBomOperationFindList({ organizationCode: this.queryParams.organizationCode }).then(res => {
          this.operationCodeList = res.rows
      })
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
.mt10{
  margin-top: 10px;
}
/deep/.ant-select{
  width: 130px !important;
}
input{
  width: 180px !important;
}
.tableInput{
  input{
    width: 100px !important;
  }
  /deep/.ant-input-number{
    width: 80px !important;
  }
  /deep/.ant-select{
    width: 100px !important;
  }
}
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
// .itemcode{
  // display: flex;
  // align-items: center;
  // /deep/.ant-form-item-children{
    // display: flex;
    // align-items: center;
  // }
// }
.code-select{
  /deep/.ant-select{
    width: 180px !important;
  }
}
.routingCode{
  width: 130px !important;
}
</style>
